import { Flex } from "@chakra-ui/react";
import { Col, Row } from "antd";
import ContentItem from "components/ContentItem";
import moment from "moment";
import { formatMoney } from "infra/helpers/number";
import { ExecucaoOrcamentaria } from "core/features/execucao-orcamentaria/typings/index";
import InformacaoTitulo from "./InformacaoTitulo";
import { RiArrowRightFill } from "react-icons/ri";

interface DescriticaoContaProps {
  item: ExecucaoOrcamentaria;
}

export default function DescricaoConta({ item }: DescriticaoContaProps) {
  return (
    <Flex w="100%" flexDir="column" gap={4}>
      <Row gutter={8}>
        <Flex as={Col} xs={5}>
          <ContentItem
            titulo="Ano"
            descricao={moment(item.dataInicio).format("YYYY")}
          />
        </Flex>
        <Flex as={Col} xs={1} align="center" />
        <Flex as={Col} xs={5}>
          <ContentItem titulo="Descrição" descricao={item.nome} />
        </Flex>

        <Flex as={Col} xs={6}>
          <ContentItem
            titulo="Taxa de inadimplência prevista "
            descricao={`${(item.taxaInadimplenciaPrevista ?? 0).toFixed(2)}%`}
          />
        </Flex>
        <Flex as={Col} xs={1} align="center">
          <RiArrowRightFill size={20} />
        </Flex>
        <Flex as={Col} xs={6}>
          <ContentItem
            titulo="Taxa de inadimplência Atual "
            tituloIcon={
              item.taxaInadimplenciaAtual > item.taxaInadimplenciaPrevista ? (
                <InformacaoTitulo />
              ) : (
                ""
              )
            }
            descricao={`${(item.taxaInadimplenciaAtual ?? 0).toFixed(2)}%`}
          />
        </Flex>
      </Row>
      <Row gutter={8}>
        <Flex as={Col} xs={5}>
          <ContentItem
            titulo="Previsão de Receitas"
            descricao={formatMoney(item.previsao.receita || 0)}
          />
        </Flex>
        <Flex as={Col} xs={1} align="center">
          <RiArrowRightFill size={20} />
        </Flex>
        <Flex as={Col} xs={5}>
          <ContentItem
            titulo="Execução das Receitas"
            tituloIcon={
              item.execucao.receita > item.previsao.receita ? (
                <InformacaoTitulo />
              ) : (
                ""
              )
            }
            descricao={formatMoney(item.execucao.receita || 0)}
          />
        </Flex>
        <Flex as={Col} xs={6}>
          <ContentItem
            titulo="Previsão de Despesas"
            descricao={formatMoney(item.previsao.despesa || 0)}
          />
        </Flex>
        <Flex as={Col} xs={1} align="center">
          <RiArrowRightFill size={20} />
        </Flex>
        <Flex as={Col} xs={6}>
          <ContentItem
            titulo="Execução das Despesas"
            tituloIcon={
              item.execucao.despesa > item.previsao.despesa ? (
                <InformacaoTitulo />
              ) : null
            }
            descricao={formatMoney(item.execucao.despesa || 0)}
          />
        </Flex>
      </Row>
    </Flex>
  );
}
